<template>
    <div class="box">
        <div class="form">
             <div class="my-field">
                <div class="label">取货人</div>
                <div class="content">
                    <span>{{ entrustment.pickUpUserName }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', entrustment.pickUpUserTel, 6)" href="javascript:void(0)" />
                </div>
            </div>
            <!-- <van-field
                readonly
                center
                clearable
                label="取货人"
                :value="entrustment.pickUpUserName"
            >
                <template #button>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', entrustment.pickUpUserTel)" href="javascript:void(0)" />
                </template>
            </van-field> -->

            <van-field label="取货时间" :value="entrustment.time" readonly />
            <van-field label="处置机构" :value="disposalDetails.optMechanismName" readonly />
            <van-field v-if="entrustment && entrustment.signAttachment" label="取货人签名" readonly />
            <div v-if="entrustment && entrustment.signAttachment" class="signImg">
                <img v-if="entrustment && entrustment.signAttachment" :src="entrustment.signAttachment" alt="">
            </div>
            <van-field label="相关凭证" readonly />
            <div class="imglist">
                <img @click="preview(entrustment.pickUp, index)" :src="i" v-for="(i, index) in entrustment.pickUp" :key="index" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import util from '../../../../utils/common'
    import { ImagePreview } from 'vant'

    export default {
        data () {
            return {
                detail: {},
                entrustment: {
                    pickUp: []
                }
            }
        },
        created () {
            this.detail = this.$store.state.refund.detail
            console.log(this.detail, '退货单详情')
            if (this.$store.state.refund.detail.entrustment) {
                this.entrustment = this.$store.state.refund.detail.entrustment
                console.log('entrustment', this.entrustment)
            }
            this.setDetail()
        },
        methods: {
            preview (imglist, index) {
                  window.history.pushState(null, null, "#");
                const that = this
                ImagePreview({
                    images: imglist,
                    startPosition: index,
                       onClose() {
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('pickupInformationDetails') === -1) {
                        that.$router.back()
                      }
                    }
                })
            },
            setDetail () {
                if (this.detail && this.detail.history) {
                    this.disposalDetails = this.detail.history.find(i => i.optText === '已反馈取货结果')
                    this.disposalDetails.time = util.getStampInDate(this.disposalDetails.pickUpTime, '/')
                }
                if (this.entrustment) {
                    this.entrustment.time = util.getStampInDate(this.entrustment.pickUpTime, '/')
                    if (this.detail && this.detail.attachments && this.detail.attachments.pickUp) {
                        if (this.detail.attachments.pickUp.length > 0) {
                            this.entrustment.pickUp = []
                            this.detail.attachments.pickUp.map(i => {
                                this.entrustment.pickUp.push(i.fileUrl)
                            })
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
     .box {
        padding: 16px 16px 0;
        background-color: #f8f9fc;
        min-height: 100vh;
        /deep/.form {
            margin-bottom: 16px;
            border-radius: 4px;
            background-color: white;

            .van-field__label {
                width: 56px;
                margin-right: 16px;
            }
            .van-cell::after {
                border-bottom: 0;
            }
             .my-field {
                background-color: white;
                display: flex;
                align-items: center;
                padding: 10px 0;
                margin: 0 16px;
                border-bottom: 0.1px solid #ebedf0;

                .label {
                    color: #646566;
                    font-size: 14px;
                    width: 56px;
                    margin-right: 16px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #323233;
                      .call-icon {
                            display: inline-block;
                            width: 25px;
                            height: 25px;
                            background-color: #e9f7f1;
                            background-image: url('../../../../assets/refund/icon_ts_dh@2x.png');
                            background-repeat: no-repeat;
                            background-size: 100%;
                            background-position: center;
                            border-radius: 50%;}
                    span {
                        margin-right: 10px;
                    }
                }
            }
            .signImg {
                border-radius: 4px;
                background-color: white;
                padding: 0 16px 16px;
                width: 100%;
                height: 280px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #f9f9f9;
                    background-color: #f8f9fb;
                }
            }
            .imglist {
                display: flex;
                background-color: white;
                padding: 0 16px 16px;

                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                    border-radius: 4px;
                }
            }
            .call-icon {
                display: inline-block;
                width: 24px;
                height: 24px;
                background-image: url('../../../../assets/refund/icon_ts_dh@2x.png');
            }
        }
    }
</style>
